import { type VoidFunctionComponent } from 'react';

import Button, { BUTTON_SIZE, LoaderButton } from '../../../generic/Button';

import styles from './Buttons.module.less';

type Props = {
  /**
   * Whether the snippet is rejected.
   */
  isRejected: boolean;
  /**
   * Whether a snippet is currently being rejected.
   */
  isRejecting?: boolean;
  /**
   * Handler when the reject button is clicked.
   */
  onRejectClick: () => void;
  /**
   * Whether a snippet is currently being unrejected.
   */
  isUnrejecting?: boolean;
  /**
   * Handler when the stop rejecting button is clicked.
   */
  onUnrejectClick: () => void;
  /**
   * Handler when "Download" button is clicked.
   */
  onDownloadClick: () => void;
};

/**
 * Action buttons for the SnippetsDrawer
 */
const SnippetsDrawerButtons: VoidFunctionComponent<Props> = ({
  isRejected,
  isRejecting,
  onRejectClick,
  isUnrejecting,
  onUnrejectClick,
  onDownloadClick,
}) => (
  <div className={styles.buttons}>
    {isRejected ? (
      <LoaderButton
        type="secondary"
        size={BUTTON_SIZE.MEDIUM}
        onClick={onUnrejectClick}
        isLoading={isUnrejecting}
      >
        Stop Rejecting
      </LoaderButton>
    ) : (
      <LoaderButton
        type="secondary"
        size={BUTTON_SIZE.MEDIUM}
        onClick={onRejectClick}
        isLoading={isRejecting}
      >
        Reject
      </LoaderButton>
    )}
    <Button
      type="secondary"
      size={BUTTON_SIZE.MEDIUM}
      onClick={onDownloadClick}
    >
      Download Match Data
    </Button>
  </div>
);

export default SnippetsDrawerButtons;
